export default "__VITE_ASSET__DYyQmrYi__"